
import clienteAxios from "../config/axios";

export const getAllPeligro = async () => {
    return clienteAxios.get('/peligro');
};
export const addPeligro = async (peligro) => {
    return await clienteAxios.post('/peligro',{peligro});
}
export const updatePeligro = async (peligro) => {
    return await clienteAxios.put(`peligro/${peligro.id}`,{peligro});
}
export const deletePeligro = async (peligroID,tDocID) => {
    return await clienteAxios.delete(`peligro/${peligroID}`,{data: {tDocID:tDocID}});
}
